import * as React from 'react';
import { Component } from 'react';
import { Manager, Reference, Popper, PopperChildrenProps } from 'react-popper';

export type  ITooltipUIProps = Pick<PopperChildrenProps, 'placement'> & {
    baseElement: JSX.Element;
    tooltipContent: JSX.Element;
};



export interface ITooltipState {
    showTooltip: boolean;
}

class TooltipUI extends Component<ITooltipUIProps, ITooltipState> {
    tooltipRef: any;

    constructor(props: ITooltipUIProps) {
        super(props);
        this.state = {
            showTooltip: false
        };
    }

    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick = (e) => {
        if (this.tooltipRef) {
            if (this.tooltipRef.contains(e.target)) {
                return;
            }
            this.hideTooltip();
        }
    }

    hideTooltip = () => {
        this.setState({ showTooltip: false });
    }

    toggleShowToolTipMessage = () => {
        this.setState({ showTooltip: !this.state.showTooltip });
    }

    render() {
        return (
            <Manager>
                <Reference>
                {({ ref }) => {
                    const clonedBaseElement = React.cloneElement(this.props.baseElement, {
                        ref,
                        onClick: this.toggleShowToolTipMessage
                    });
                    return clonedBaseElement;
                }}
                </Reference>
                {this.state.showTooltip ?
                    <Popper placement={this.props.placement}>
                    {({ ref, style, placement, arrowProps }) => {
                        return (
                            <div className="tool-tip-container" ref={ref} style={style} data-placement={placement}>
                                <div className="tool-tip-message" ref={node => this.tooltipRef = node}>
                                    {this.props.tooltipContent}
                                    <div className="message-link-container">
                                        <a onClick={this.hideTooltip} className="message-link">Close</a>
                                    </div>
                                </div>
                                <div ref={arrowProps.ref} style={arrowProps.style} />
                            </div>
                        );
                    }}
                    </Popper>
                : null}
            </Manager>
        );
    }
}

export default TooltipUI;
